import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Load Meta Pixel script
    if (typeof window !== 'undefined' && !window.fbq) {
      ;
      (function (f: any, b: Document, e: string, v: string, n: any, t: any) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        b.head.appendChild(t);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null);
      // Initialize pixel
      window.fbq('init', '900170219857277');
      // Track PageView
      window.fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-387">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=900170219857277&ev=PageView&noscript=1" alt="" data-id="element-388" />
    </noscript>;
}